
import React from 'react';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';

interface BookingsTabsProps {
  activeTab: string;
  setActiveTab: (value: string) => void;
}

export const BookingsTabs: React.FC<BookingsTabsProps> = ({ activeTab, setActiveTab }) => {
  return (
    <div className="flex items-center justify-between">
      <Tabs defaultValue="upcoming" className="w-auto" value={activeTab} onValueChange={setActiveTab}>
        <TabsList className="grid w-full grid-cols-2 h-9">
          <TabsTrigger value="upcoming" className="text-xs px-3">Upcoming</TabsTrigger>
          <TabsTrigger value="past" className="text-xs px-3">Past</TabsTrigger>
        </TabsList>
      </Tabs>
      
      <Button size="sm" className="flex items-center gap-1">
        <Plus className="h-3.5 w-3.5" />
        <span>New</span>
      </Button>
    </div>
  );
};
